<template>
  <div ref="headerPageWrapper" id="header-page-wrapper">
    <div class="header-wrapper">
      <div class="flex-row align-items-center justify-content-between pb-lg container-h-xxl">
        <dd-page-header
            :backHandler="backHandler"
            :bread-crumbs="breadCrumbs"
        >
          {{ header }}
        </dd-page-header>
        <div class="flex-row justify-content-end align-items-center gap-md mt-xl">
          <slot name="header-buttons"></slot>
        </div>
      </div>
      <div class="flex-row align-items-end justify-content-between">
        <slot name="tabs"></slot>
        <slot name="instance-buttons"></slot>
      </div>
    </div>

    <div class="flex-row">
      <div class="content container-v-lg" :class="{'has-buttons': hasButtons, 'pt-0': !hasTabs} ">
        <slot class="flex-shrink-1" name="content"></slot>
      </div>
      <dd-thin-button-wrapper
          v-show="hasButtons"
          @buttons-loaded="buttonsLoaded"
          :expanded="buttonsExpanded"
          :showShadow="!buttonsExpanded"
      >
        <slot name="buttons"></slot>
      </dd-thin-button-wrapper>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import store from "./store";
export default {
  name: "HeaderPage.vue",
  props: {
    header: {
      required: true,
      type: String
    },
    breadCrumbs: {
      type: Array,
      required: false,
    },
    backHandler: {
      type: Function,
      required: false,
    },
  },
  created() {
    const STORE_KEY = `$_header_page`;
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  methods: {
    ...mapActions(`$_header_page`, {
      listenForResize: `listenForResize`
    }),
    buttonsLoaded() {
      this.listenForResize(this.$refs.headerPageWrapper);
    },
  },
  computed: {
    ...mapState(`$_header_page`, {
      buttonsExpanded: state => state.buttonsExpanded,
    }),
    hasButtons() {
      return this.$slots.buttons?.length > 0;
    },
    hasTabs() {
      return this.$slots.tabs?.length > 0;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.content.has-buttons {
  margin-right: 92px;
}
.content {
  width: 100%;
  min-width: 0;
  max-width: 100% !important;
  height: 100%;
  overflow-x: clip;
  padding-left: $spacing-xxl;
  padding-right: $spacing-xxl;
}
.header-wrapper {
  background-color: white;
  padding-top: $spacing-xl;
}
.customer-page {
  display: flex;
  position: relative;
  gap: $spacing-md;
  background-color: $main-content-bg-color;
  //.content {
  //  flex-grow: 1;
  //  flex-shrink: 0;
  //}
  height: 100%;
  .action-buttons {
    flex-grow: 0;
    flex-shrink: 1;
  }

}
</style>
